/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ step: NonNullable<unknown> }} Automation_Trigger_Step_ChangedInputs */

const en_automation_trigger_step_changed = /** @type {(inputs: Automation_Trigger_Step_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Case entered ${i?.step}`)
};

const pt_br2_automation_trigger_step_changed = /** @type {(inputs: Automation_Trigger_Step_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caso entrou em ${i?.step}`)
};

/**
* | output |
* | --- |
* | "Case entered {step}" |
*
* @param {Automation_Trigger_Step_ChangedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_trigger_step_changed = /** @type {((inputs: Automation_Trigger_Step_ChangedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Trigger_Step_ChangedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_trigger_step_changed(inputs)
	return pt_br2_automation_trigger_step_changed(inputs)
});